import TextButton from 'components/Luxkit/Button/TextButton'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import useToggle from 'hooks/useToggle'
import React, { forwardRef, useRef } from 'react'
import BusinessTravellerAccountMenuContent from './BusinessTravellerAccountMenuContent'
import { useIsMobileScreen } from 'lib/deviceUtils'
import BusinessAccountModeIcon from './BusinessAccountModeIcon'

interface Props {
  className?: string
}

const MENU_TITLE = 'Your account'

const BusinessTravellerAccountButtonMenu = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { off, value, toggle } = useToggle()
  const triggerRef = useRef<HTMLButtonElement>(null)
  const isMobileScreen = useIsMobileScreen()

  return <div ref={ref}>
    <TextButton
      ref={triggerRef}
      kind="tertiary"
      variant="dark"
      startIcon={<BusinessAccountModeIcon />}
      onClick={toggle}
    >
      Account
    </TextButton>
    <Dropdown open={value && !isMobileScreen} onClose={off} triggerRef={triggerRef}>
      <DropdownContainer title={MENU_TITLE}>
        <BusinessTravellerAccountMenuContent onListItemClick={off} />
      </DropdownContainer>
    </Dropdown>
  </div>
})

export default BusinessTravellerAccountButtonMenu
